'use strict';

import 'document-register-element';
import dispatcher from '../dispatcher';
import {TimelineMax} from 'gsap/TimelineMax';

class MainGegraphy extends HTMLElement{
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
    this.count = 3;

    this.play = () => this._play();
  }
  connectedCallback() {
    this.info = this.querySelector('.geography-info');
    this.num = this.querySelector('.geography-info-num');
    this.paths = Array.from(this.querySelectorAll('path'));

    const length = Math.ceil(this.paths.length / this.count);


    this.timeline = new TimelineMax({paused: true});

    for (let i = 0; this.count > i; i++) {
      const paths = this.paths.splice(0, length);

      this.timeline.staggerFromTo(paths, 1, {
        scale: 0.5,
        opacity: 0
      }, {
        scale: 1,
        opacity: 1
      }, 0.05, i * 0.1 + 0.1)
    }

    const numObj = {
      num: 0
    };
    this.timeline.to(numObj, 1 + 0.05 * length, {
      num: +this.num.innerHTML,
      onUpdate: () => {
        this.num.innerHTML = Math.round(numObj.num).toString()
      }
    }, 0.3);
    this.timeline.fromTo(this.info, 1, {
      opacity: 0,
      y: 50
    }, {
      opacity: 1,
      y: 0
    }, 0.3);


    this.num.innerHTML = '0';
  }

  _play() {
    this.timeline.play();
  }
}

window.customElements.define('main-geography', MainGegraphy);
